import { overrideRequired } from '@emico/overrides'

// eslint-disable-next-line @typescript-eslint/ban-types
export default overrideRequired<{}>('Logo')
